import React from 'react';
import { format, addYears } from 'date-fns';
import { FieldProps } from 'formik';
import { Select, Option } from '@xo-union/tk-component-fields';
import { SeasonName } from './types';

export const SeasonDropdown: React.FC<FieldProps> = ({
  field: { name, value },
  form: { setFieldValue, errors },
}: FieldProps) => {
  const state = errors.season ? 'invalid' : undefined;
  return (
    <Select
      data-testid="season-dropdown"
      name={name}
      value={value}
      state={state}
      label="Season"
      onChange={({ option }: any): void => {
        const newValue: SeasonName = option.value;
        setFieldValue(name, newValue);
      }}
    >
      <Option value={SeasonName.Winter} />
      <Option value={SeasonName.Spring} />
      <Option value={SeasonName.Summer} />
      <Option value={SeasonName.Fall} />
    </Select>
  );
};

export const YearDropdown: React.FC<FieldProps> = ({
  field: { name, value },
  form: { setFieldValue, errors },
}: FieldProps) => {
  const yearsOutLimit = 5;
  const today = new Date(Date.now());
  const years = Array.from({ length: yearsOutLimit }).map((_, i) => format(addYears(today, i), 'yyyy'));
  const state = errors.year ? 'invalid' : undefined;
  return (
    <Select
      data-testid="year-dropdown"
      name={name}
      value={value}
      state={state}
      onChange={({ option }: any): void => setFieldValue(name, option.value)}
    >
      {years.map(y => (
        <Option value={y} key={y} />
      ))}
    </Select>
  );
};
